import type { OnboardingProgress } from '@lipaflow/shared'

export const isAdminAssistedSetupPending = (
  progress: OnboardingProgress | null | undefined,
): boolean => Boolean(progress?.is_admin_setup && !progress.is_complete)

export const shouldUseSelfServiceOnboarding = (
  progress: OnboardingProgress | null | undefined,
  role: string | null | undefined,
): boolean => Boolean(
  progress &&
  !progress.is_complete &&
  !progress.is_admin_setup &&
  role === 'admin',
)
